import { atom } from 'jotai';

const errorBoxOpenAtom = atom(false);

export { errorBoxOpenAtom };
